import React, { useEffect, useRef, useState } from 'react';
import { StaticImage } from "gatsby-plugin-image";
import scrollLock from 'scroll-lock';
import { getLang, browser, getSignupUrl, IS_SERVER } from "../../../../common";
import { translation } from "../../../../translations/bonus30or35/translation";
import ModalRegForm from "../../../templateElements/modalRegForm";

const ZenitBonus = ({ brandName, sumValue, currency, lang, langId, promoObject, isRegFormNeeded, countryData, currencyData, landingName }) => {
  const [btnText, setBtnText] = useState('');
  const [signupUrl, setSignupUrl] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const gatsbySettingsFull = {
    placeholder: 'blurred',
    quality: 60,
    layout: 'fullWidth',
  };

  const getText = textKey => `${getLang(translation, brandName, lang, textKey)}`;

  const onRegBtnClick = () => {
    setIsModalVisible(true)
    !IS_SERVER && document.querySelector('html').classList.add('lock-window')
    scrollLock.disablePageScroll();
  }

  const closeModal = () => {
    setIsModalVisible(false);
    !IS_SERVER && document.querySelector('html').classList.remove('lock-window')
    scrollLock.enablePageScroll();
  }

  useEffect(() => {
    setBtnText(getText('btnGet'));
    setSignupUrl(getSignupUrl(brandName, lang));
  }, []);

  return (<>
    <StaticImage
      src='../img/zenit/bg.jpg'
      alt='bg'
      className='bg-img'
      {...gatsbySettingsFull}
    />
    <main>
      <div className="img-wrapper">
        <StaticImage
          src='../img/zenit/foot-ball.png'
          alt='football'
          className='football'
          placeholder="blurred"
          quality="60"
        />
        <StaticImage
          src='../img/zenit/valley-ball.png'
          alt='volleyball'
          className='volleyball'
          placeholder="blurred"
          quality="60"
        />
        <StaticImage
          src='../img/zenit/hockey-puck.png'
          alt='hockey-puck'
          className='hockey-puck'
          placeholder="blurred"
          quality="60"
        />
      </div>
      <div className="main-wrapper container">
        <div className="main-wrapper__content">
          <div dir="ltr" className={`main-wrapper__bonus main-wrapper__bonus_${lang} wow ${browser().mac ? null : `animate__animated animate__headShake`}`}>
            {`${sumValue} ${currency}`}
          </div>
          <h1 className={`main-wrapper__title main-wrapper__title_${lang} wow ${browser().mac ? null : `animate__animated animate__fadeInRightBig`}`}>
            {getLang(translation, brandName, lang, 'title')}<span>{getLang(translation, brandName, lang, 'titleSpan')}</span>
          </h1>
          {promoObject.promo_code === 'bonus35k'}

          <div className={`main-wrapper__promo wow ${browser().mac ? null : `animate__animated animate__fadeInLeftBig`}`}>
            <span>{getLang(translation, brandName, lang, 'promoSpan')}</span>
            <div className="promo-text">
              <span>{promoObject.promo_code}</span>
            </div>
          </div>
          {isRegFormNeeded
            ?
            <div className="button-wrapper wow animate__animated animate__fadeIn">
              <button onClick={onRegBtnClick} className={`main-wrapper__btn-get main-wrapper__btn-get_${lang}`}>
                {btnText}
                <span className="border-btn-get" />
              </button>
            </div>
            :
            <div className="button-wrapper wow animate__animated animate__fadeIn">
              <a href={signupUrl} className={`main-wrapper__btn-get main-wrapper__btn-get_${lang} wow animate__animated animate__fadeIn`}>
                {btnText}
                <span className="border-btn-get" />
              </a>
            </div>
          }
          <ModalRegForm
            isModalVisible={isModalVisible}
            brandName={brandName}
            lang={lang}
            langId={langId}
            defaultCountryId={countryData}
            defaultCurrencyId={currencyData}
            defaultPromoCode={promoObject.promo_code}
            regFormTitle={getLang(translation, brandName, lang, 'regFormTitle')}
            onCloseModal={closeModal}
            landingName={landingName}
          />
        </div>
      </div>
    </main>
  </>)
}

export default ZenitBonus

